/** Ticket-scoped ownership for sticky annotation warning toasts. */
export class AnnotationWarningRegistry {
  private readonly ids = new Map<string, string>();

  has(ticketId: string): boolean {
    return this.ids.has(ticketId);
  }

  register(ticketId: string, toastId: string): void {
    this.ids.set(ticketId, toastId);
  }

  release(ticketId: string, toastId: string): void {
    if (this.ids.get(ticketId) !== toastId) return;
    this.ids.delete(ticketId);
  }

  take(ticketId: string): string | null {
    const toastId = this.ids.get(ticketId) ?? null;
    this.ids.delete(ticketId);
    return toastId;
  }
}

/** Shared across canvas remounts so a successful retry can dismiss its toast. */
export const annotationWarningRegistry = new AnnotationWarningRegistry();
